module.exports = __webpack_public_path__ + "media/images/vp/sample.course2-7bb7de019e09264f402b4cd915ffe6e6.jpg";